import React, { useContext } from 'react';
import { Badge, Box, Typography } from '@mui/material';
import {
    IconExportIncludeFiltered,
    IconExportIncludeZipImages,
    IconNoNotificationsFound,
    IconNotificationsAmount,
    IconReport,
} from '../../../../../../common/images';
import Popup from '../../../../../../common/components/Popup/Popup';
import { i18n } from 'src/common/i18n/i18n';
import { GlobalContext } from '../../../../../../common/contexts/globalContext';
import { JsonFileIcon, PdfFileIcon, ZipFileIcon } from '@cellebrite/saas-ui-icons';
import { COLORS } from '@cellebrite/saas-ui-common';
import { ElementsDivider } from '@cellebrite/saas-ui-common';
import { dateFormatter } from '../../../../../../common/utils/formatters';
const Notifications = () => {
    const { notificationsData } = useContext(GlobalContext);

    return (
        <Popup
            actionElement={(handleOpen, anchorReference, isOpen) => (
                <Box
                    className={isOpen ? 'background-color-blst' : 'background-color-mho'}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        ml: 1,
                        mr: 1,
                        p: 1,
                        borderRadius: '61px',
                        cursor: 'pointer',
                    }}
                    onClick={(e) => {
                        handleOpen();
                    }}
                    ref={anchorReference}
                >
                    <Badge
                        sx={{
                            '& .MuiBadge-badge': {
                                width: 24,
                                height: 24,
                                top: '-4px',
                                right: '-4px',
                                borderRadius: '12px',
                            },
                        }}
                        badgeContent={
                            notificationsData.notifications?.filter((notification) => !notification.viewed).length
                        }
                        color="info"
                    >
                        <IconReport fontSize="inherit" className={isOpen ? 'fill-b' : 'fill-md'} />
                    </Badge>
                </Box>
            )}
            contentElement={(handleClose) => (
                <Box sx={{ display: 'flex', flexDirection: 'column', p: 2, width: 391, maxHeight: 500 }}>
                    <Typography variant="s18w700" className="color-bd">
                        {i18n.translate('Report Center')}
                    </Typography>
                    <Box sx={{ mt: 2, height: '100%', overflow: 'auto' }}>
                        {!!notificationsData.notifications?.length ? (
                            <Box sx={{ display: 'flex', flexDirection: 'column', rowGap: 1 }}>
                                {notificationsData.notifications.map((notification) => (
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            p: 1,
                                            justifyContent: 'space-between',
                                            cursor: 'pointer',
                                        }}
                                        className="background-color-hover-blst"
                                        onClick={() => {
                                            notificationsData.viewNotification(notification);
                                            window.open(`${window.origin}/${notification.fileUrl}`, '_blank');
                                        }}
                                    >
                                        <Box sx={{ display: 'flex', overflow: 'hidden' }}>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    minWidth: 40,
                                                    width: 40,
                                                    height: 40,
                                                    backgroundColor: COLORS.BRAND_LIGHT,
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    borderRadius: '20px',
                                                }}
                                            >
                                                {notification.extractImagesToZip ? (
                                                    <ZipFileIcon width={16} height={16} viewBox="0 0 24 24" />
                                                ) : notification.exportType === 'PDF' ? (
                                                    <PdfFileIcon width={16} height={16} viewBox="0 0 24 24" />
                                                ) : (
                                                    <JsonFileIcon width={16} height={16} viewBox="0 0 24 24" />
                                                )}
                                            </Box>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    ml: 2,
                                                    overflow: 'hidden',
                                                }}
                                            >
                                                <Typography
                                                    variant="s14w700"
                                                    className="color-mh"
                                                    sx={{
                                                        textOverflow: 'ellipsis',
                                                        overflow: 'hidden',
                                                        textWrap: 'nowrap',
                                                    }}
                                                    title={notification.fileName}
                                                >
                                                    {notification.fileName}
                                                </Typography>
                                                <ElementsDivider
                                                    styles={{ flexWrap: 'unset' }}
                                                    dividerOverrides={{ height: 15, color: COLORS.MUTED_DARK }}
                                                    elements={[
                                                        <Typography
                                                            variant="s14w500"
                                                            className="color-md"
                                                            title={`${i18n.translate('Search ID')}: ${
                                                                notification.streamId
                                                            }`}
                                                        >
                                                            {`${i18n.translate('Search ID')}: ${notification.streamId}`}
                                                        </Typography>,
                                                        <Typography
                                                            variant="s14w500"
                                                            className="color-md"
                                                            sx={{ textOverflow: 'ellipsis', overflow: 'hidden' }}
                                                            title={`${i18n.translate('By')}: ${notification.createdBy}`}
                                                        >
                                                            {`${i18n.translate('By')}: ${notification.createdBy}`}
                                                        </Typography>,
                                                    ]}
                                                />
                                                <Typography variant="s12w400" className="color-md">
                                                    {dateFormatter(notification.createdDate)}
                                                </Typography>
                                                {notification.includeFilteredData && (
                                                    <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                                                        <Box sx={{ width: 20, minWidth: 20, height: 16 }}>
                                                            <IconExportIncludeFiltered />
                                                        </Box>
                                                        <Typography
                                                            variant="s12w400"
                                                            className="color-md"
                                                            sx={{ ml: 1 }}
                                                        >
                                                            {i18n.translate('Exported with filtered data only')}.
                                                        </Typography>
                                                    </Box>
                                                )}
                                                {notification.extractImagesToZip && (
                                                    <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                                                        <IconExportIncludeZipImages />
                                                        <Typography
                                                            variant="s12w400"
                                                            className="color-md"
                                                            sx={{ ml: 1 }}
                                                        >
                                                            {i18n.translate('Exported with images to a zip file')}.
                                                        </Typography>
                                                    </Box>
                                                )}
                                            </Box>
                                        </Box>
                                        <Box
                                            sx={{
                                                m: 1,
                                                width: 8,
                                                minWidth: 8,
                                                height: 8,
                                                backgroundColor: notification.viewed ? 'transparent' : '#7025D2',
                                                borderRadius: '4px',
                                            }}
                                        ></Box>
                                    </Box>
                                ))}
                                <Box
                                    sx={{
                                        borderTop: `1px solid ${COLORS.MUTED_LIGHTEST}`,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        py: 4,
                                    }}
                                >
                                    <IconNotificationsAmount />
                                    <Typography variant="s12w400" className="color-md" sx={{ mt: 1 }}>
                                        {i18n.translate('NOTIFICATIONS_LATEST_REPORTS_AMOUNT', {
                                            amount: notificationsData.notifications.length,
                                        })}
                                    </Typography>
                                    <Typography variant="s12w400" className="color-md">
                                        {i18n.translate('in this workspace')}.
                                    </Typography>
                                </Box>
                            </Box>
                        ) : (
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: '100%',
                                    rowGap: 2,
                                }}
                            >
                                <IconNoNotificationsFound />
                                <Typography variant="s16w700" className="color-bd">
                                    {i18n.translate('No reports exported yet')}
                                </Typography>
                            </Box>
                        )}
                    </Box>
                </Box>
            )}
        />
    );
};

export default Notifications;
